module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Contents")]), _c('ol', [_c('li', {
    attrs: {
      "id": "level1-titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-toc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front04"
    }
  }, [_vm._v("Maps of Area")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Among the Unreal People")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("The Train from Khayelitsha")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cape Town")]), _vm._v(": The Spirit of the Cape")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Night Bus to Windhoek")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Night Train from Swakopmund")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bush Track to Tsumkwe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ceremony at the Crossroads")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Among the Real People")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riding an Elephant: The Ultimate Safari")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hungry Herds at Etosha")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Frontier of Bad Karma")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Pieces of Chicken")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volunteering in Lubango")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Slave Yards of Benguela")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luanda: The Improvised City")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This Is What the World Will Look Like When It Ends”")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Am I Doing Here?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming Soon from Paul Theroux")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read More from Paul Theroux")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-footnotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/footnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Footnotes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0